"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publicKeyv1 = publicKeyv1;
exports.serializePathv1 = serializePathv1;
exports.signSendChunkv1 = signSendChunkv1;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _common = require("./common");

/** @param {import('./types').DerivationPath} path */
function serializePathv1(path) {
  // length 3: ADR 8 derivation path
  // length 5: Legacy derivation path
  if (!path || path.length !== 3 && path.length !== 5) {
    throw new Error("Invalid path.");
  }
  /* eslint no-bitwise: "off", no-plusplus: "off" */


  var buf = Buffer.alloc(path.length * 4);

  for (var i = 0; i < path.length; i++) {
    // Harden all path components by ORing them with 0x80000000.
    var hardened = (0x80000000 | path[i]) >>> 0;
    buf.writeUInt32LE(hardened, i * 4);
  }

  return buf;
}
/** @param {import('./types').App} app */


function signSendChunkv1(_x, _x2, _x3, _x4) {
  return _signSendChunkv.apply(this, arguments);
}
/** @param {import('./types').App} app */


function _signSendChunkv() {
  _signSendChunkv = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(app, chunkIdx, chunkNum, chunk) {
    var payloadType;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payloadType = _common.PAYLOAD_TYPE.ADD;

            if (chunkIdx === 1) {
              payloadType = _common.PAYLOAD_TYPE.INIT;
            }

            if (chunkIdx === chunkNum) {
              payloadType = _common.PAYLOAD_TYPE.LAST;
            }

            return _context.abrupt("return", app.transport.send(_common.CLA, _common.INS.SIGN_ED25519, payloadType, 0, chunk, [0x9000, 0x6984, 0x6a80]).then(function (response) {
              var errorCodeData = response.slice(-2);
              var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
              var errorMessage = (0, _common.errorCodeToString)(returnCode);

              if (returnCode === 0x6a80 || returnCode === 0x6984) {
                errorMessage = "".concat(errorMessage, " : ").concat(response.slice(0, response.length - 2).toString("ascii"));
              }

              var signature = null;

              if (response.length > 2) {
                signature = response.slice(0, response.length - 2);
              }

              return {
                signature: signature,
                return_code: returnCode,
                error_message: errorMessage
              };
            }, _common.processErrorResponse));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _signSendChunkv.apply(this, arguments);
}

function publicKeyv1(_x5, _x6) {
  return _publicKeyv.apply(this, arguments);
}

function _publicKeyv() {
  _publicKeyv = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(app, data) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", app.transport.send(_common.CLA, _common.INS.GET_ADDR_ED25519, 0, 0, data, [0x9000]).then(function (response) {
              var errorCodeData = response.slice(-2);
              var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
              return {
                pk: Buffer.from(response.slice(0, 32)),
                return_code: returnCode,
                error_message: (0, _common.errorCodeToString)(returnCode)
              };
            }, _common.processErrorResponse));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _publicKeyv.apply(this, arguments);
}